import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import assetify from "@quintype/framework/assetify";
import { object, array, bool, string } from "prop-types";

import NewsWithImage from "../../../molecules/NewsWithImage";
import LeftImageRightNews from "../../../molecules/LeftImageRightNews";

import EpaperImage from "../../../../../assets/images/epaper.png";

import "./row2rightcolumn.m.css";

const Row2RightColumn = ({
  stories,
  publisherAttributes,
  newsSectionArray,
  showSectionTag,
  adSlotId1,
  selectedTagName = "",
  headlineSpecialColor = "",
}) => {
  const row2FirstVideoStories = stories.slice(0, 1);
  const row2SecondStories = stories.slice(1, 2);
  const sportsNews = newsSectionArray && newsSectionArray.sportsNews ? newsSectionArray.sportsNews : "";
  const videoNews = newsSectionArray && newsSectionArray.videoNews ? newsSectionArray.videoNews : "";
  return (
    <div styleName="right_box">
      {row2FirstVideoStories.length > 0 && (
        <NewsWithImage
          story={row2FirstVideoStories[0].story}
          sectionData={videoNews}
          aspectRatio={[16, 9]}
          imageType="image16x9"
          showSectionTag={showSectionTag}
          datatrackinglabelpos={12}
          selectedTagName={selectedTagName}
          headlineSpecialColor={headlineSpecialColor}
        />
      )}
      {row2SecondStories.length > 0 && (
        <LeftImageRightNews
          story={row2SecondStories[0].story}
          sectionData={sportsNews}
          showSectionTag={showSectionTag}
          datatrackinglabelpos={13}
          selectedTagName={selectedTagName}
          headlineSpecialColor={headlineSpecialColor}
        />
      )}
      <div styleName="epaper_ad" id={adSlotId1}>
        <a
          target="_blank"
          rel="noreferrer"
          styleName="epaper_ad_wrapper"
          href="https://epaper.prothomalo.com/home.php?ref=ine1"
          data-tracking-category="Component One"
          data-tracking-action="Click"
          data-tracking-label="Epaper Fixed Banner"
        >
          <div styleName="text_wrapper">ছাপা কাগজের মতো পড়ুন আজকের পত্রিকা</div>
          <div styleName="image_wrapper">
            <img src={`${assetify(EpaperImage)}`} alt="banner" />
          </div>
        </a>
      </div>
    </div>
  );
};

Row2RightColumn.propTypes = {
  stories: array.isRequired,
  publisherAttributes: object,
  newsSectionArray: object,
  showSectionTag: bool,
  adSlotId1: string,
  selectedTagName: string,
  headlineSpecialColor: string,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps)(Row2RightColumn);
